<template>
    <div>
        <form id="pub_form" name="pub_form" method="post" action="#">
            <input type="hidden" name="rec_cert" v-model="rec_cert">
            <input type="hidden" name="certNum"  v-model="certNum">
        </form>
        <v-dialog/>
    </div>
</template>
<script>
import {kmcPublAuthResult} from '@/api/step3/identificationVerfication'
export default {
    name: "ResultKmcPublAuthPop",
    data() {
      //  return {rec_cert:'',certNum:''}

      return {
            r_certNum:'',
            r_date:'',
            r_phoneNo:'',
            r_phoneCorp:'',
            r_birthDay:'',
            r_gender:'',
            r_nation:'',
            r_name:'',
            r_result:'',
            r_resultCode:'',
            rec_cert: '',
            termConditionCheckedStatus:'',
            r_Ci:''
        }
    },
    created() {
        this.getInfo();
    },
    watch: {
    // 라우트가 변경되면 메소드를 다시 호출됩니다.
    '$route': 'getInfo'
    },
    methods: {
        /** 
         * Function    : getInfo
         * Description : KMC 결과 정보
         **/
        getInfo() {
          //  alert( this.$route.query.msgCd)
            let msgCd = this.$route.query.msgCd

            if(msgCd === "SUCCESS" ){
                 if(typeof(window.parent.cbAuthPop) == "function") {
                        window.parent.cbAuthPop(msgCd)
                    } else {
                        window.opener.cbAuthPop(msgCd)
                    }
                    window.close()

            }else{
                alert('본인 인증을 실패했습니다.');
                window.close()
            }

        },
    },
}
</script>

<style scoped>

</style>